// Testi verificati sulla dashboard il 2026-10-16 (vedi spec guide richieste, note spese e report).
// I riferimenti di legge vengono dal codice: da far rileggere prima del rilascio.
export default {
  slug: 'trasparenza',
  module: 'payTransparency',
  title: 'La trasparenza retributiva',
  tile: 'Confronta le retribuzioni di uomini e donne e rispondi alle richieste dei dipendenti.',
  minutes: 6,
  publishedAt: '2026-10-26T12:00:00.000Z',
  moduleLabel: 'Apri la trasparenza retributiva',
  modulePath: 'payTransparency',
  brief: {
    purpose:
      'Confrontare le retribuzioni di uomini e donne e rispondere alle richieste di informazioni dei dipendenti, come previsto dal D.Lgs. 96/2026.',
    who: 'Chi in azienda segue retribuzioni e personale.',
    when: 'Quando arriva una richiesta e periodicamente, per controllare il divario.',
  },
  steps: [
    {
      title: 'Le quattro schede',
      text: 'Richieste, Gruppi omogenei, Analisi azienda e Configurazione: ognuna ha un compito.',
      screen: 'trasparenza-1',
      notes: ['Richieste: le domande dei dipendenti', 'Gruppi omogenei e Analisi azienda: il confronto delle retribuzioni', 'Configurazione: come si calcola la retribuzione'],
    },
    {
      title: 'Scegli la base di calcolo',
      text: 'In «Configurazione» scegli «RAL» oppure «Elementi retributivi» e premi «Salva base di calcolo».',
      screen: 'trasparenza-2',
      notes: ['«RAL» o «Elementi retributivi»', 'Salva la scelta'],
    },
    {
      title: 'Crea i gruppi omogenei',
      text: 'In «Gruppi omogenei» premi «Nuovo gruppo»: scegli «Stesso lavoro» o «Lavoro di pari valore», CCNL e livello, poi «Salva».',
      screen: 'trasparenza-3',
      notes: ['«Stesso lavoro» o «Lavoro di pari valore»', 'CCNL e livello del gruppo'],
    },
    {
      title: "Leggi l'analisi",
      text: 'In «Analisi azienda» vedi il divario tra uomini e donne per gruppo e per azienda: sotto il 3% è «Nella norma», dal 3% «Da monitorare», dal 5% «Oltre la soglia del 5%».',
      screen: 'trasparenza-4',
      notes: ['Il divario di ogni gruppo omogeneo', 'Il colore dice se è nella norma o da controllare'],
      tip: 'Puoi spostare dipendenti tra gruppi e simulare una retribuzione: i dati reali non cambiano finché non salvi gli spostamenti.',
    },
    {
      title: 'Registra la richiesta di un dipendente',
      text: 'In «Richieste» premi «Nuova richiesta», indica dipendente, data e modalità di ricezione e premi «Registra». La colonna «Mancano» mostra i giorni alla scadenza.',
      screen: 'trasparenza-5',
      notes: ['«Nuova richiesta» registra la domanda del dipendente', '«Mancano»: i giorni che restano per rispondere'],
    },
    {
      title: 'Rispondi alla richiesta',
      text: 'Apri la pratica con «Visualizza»: premi «Elabora», poi «Genera prospetto + lettera», «Scarica» e infine «Segna come inviata».',
      screen: 'trasparenza-6',
      notes: ['«Elabora» calcola le medie per il dipendente', '«Genera prospetto + lettera» prepara la risposta', '«Segna come inviata» chiude il lavoro'],
    },
  ],
  faq: [
    {
      question: 'Ogni quanto un dipendente può fare richiesta?',
      answer:
        'Di norma una volta l’anno: se c’è già una richiesta negli ultimi 12 mesi, HeyJob ti avvisa e chiede una motivazione per registrarla comunque.',
    },
    {
      question: 'Cosa significa l’avviso «Gruppo ridotto o sbilanciato»?',
      answer:
        'Il gruppo ha poche persone o quasi tutte dello stesso sesso: i dati potrebbero far riconoscere qualcuno, quindi vanno trattati con attenzione.',
    },
  ],
};
